"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6.26 9 12 13.47 17.74 9 12 4.53z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m19.37 12.8-7.38 5.74-7.37-5.73L3 14.07l9 7 9-7zM12 2 3 9l1.63 1.27L12 16l7.36-5.73L21 9zm0 11.47L6.26 9 12 4.53 17.74 9z"
}, "1")], 'LayersTwoTone');